// Chooses how people sign in, from the build's environment:
//   VITE_API_URL unset           → demo data, no sign-in
//   VITE_AUTH_MODE=supabase      → VITE_SUPABASE_URL, VITE_SUPABASE_KEY (publishable key)
//   VITE_AUTH_MODE=oidc          → VITE_OIDC_AUTHORITY, VITE_OIDC_CLIENT_ID, VITE_OIDC_LABEL
// VITE_AUTH_HINT is shown under the sign-in heading (e.g. "Use your CertTrack sign-in").
// The providers are loaded only when used, so the demo build stays small.
import type { AuthClient } from './types';

export * from './types';

export interface AuthConfig {
  hint?: string;
  load: () => Promise<AuthClient>;
}

export function authConfig(env: Record<string, string | undefined> = import.meta.env as Record<string, string | undefined>): AuthConfig | null {
  if (!env.VITE_API_URL) return null;
  const hint = env.VITE_AUTH_HINT;
  if ((env.VITE_AUTH_MODE ?? 'supabase') === 'oidc') {
    const authority = need(env, 'VITE_OIDC_AUTHORITY');
    const client = need(env, 'VITE_OIDC_CLIENT_ID');
    return { hint, load: async () => (await import('./oidc')).oidcAuth(authority, client, env.VITE_OIDC_LABEL ?? 'Sign in with your company account') };
  }
  const url = need(env, 'VITE_SUPABASE_URL');
  const key = need(env, 'VITE_SUPABASE_KEY');
  return { hint, load: async () => (await import('./supabase')).supabaseAuth(url, key) };
}

function need(env: Record<string, string | undefined>, name: string): string {
  const v = env[name];
  if (!v) throw new Error(`${name} is not set. See web/apps/ledger/.env.example.`);
  return v;
}
